export default __webpack_public_path__ + "static/media/Aetonix_icon.f59f1fa8.png";